export { default as amazonService } from './amazon-service'